import React, { Component, Fragment } from 'react';
import DateInput from 'src/ui/library/DateInput';
import InfoTooltip from 'src/ui/library/ToolTip/InfoTooltip';
import iconTransform from 'src/helpers/iconTransform.js';
import transformDisplayText from 'src/helpers/transformDisplayText';
import { DEFAULT_CONTROL_FONT_SIZES } from 'src/constants/constants';

export default class DateControl extends Component {
  onChange = value => {
    this.props.onChange({ target: { value } });
  };

  renderDatePicker = () => {
    const { required, value, label, from, to, hasError, readOnly, align } = this.props;

    return (
      <DateInput
        required={required}
        label={label}
        onChange={this.onChange}
        value={value || ''}
        minDate={from}
        maxDate={to}
        hasError={hasError}
        disabled={readOnly}
        disableUnderline={false}
        format="DD-MMM-YYYY"
        inputMode="editable"
        styleType="questionnaire"
        align={align}
        name="dateControl"
      />
    );
  };

  render() {
    const { helpText, description, hasParentTable, align, icon, showText, ...otherProps } = this.props;

    const alignClass = align === 'R' ? 'right-align' : align === 'C' ? 'center-align' : 'left-align';

    let finalText = '';
    finalText = transformDisplayText(description, DEFAULT_CONTROL_FONT_SIZES[otherProps.origControlTypeName], otherProps.increaseFontSize);
    finalText = showText === true ? finalText : '';

    return (
      <Fragment>
        <div className={`control-text flex-column ${alignClass}`}>
          {finalText && !hasParentTable ? (
            <div className={`control-wrapper ${align === 'C' ? 'justifyCenter' : ''}`}>
              {icon && <div className={'control-icons control-icons-inline'}></div>}
              <div className={'control-icons-inline-controls label-field'}>
                <span component="legend" className="control-label">
                  {finalText}
                </span>
              </div>
            </div>
          ) : null}
          {
            <div className={`control-wrapper ${align === 'C' ? 'justifyCenter' : ''}`}>
              {icon && <div className={'control-icons control-icons-inline'}>{iconTransform(icon)}</div>}
              <div className={`control-icons-inline-controls ${helpText ? 'with-tooltip' : ''} ${icon ? 'with-icon' : ''}`}>
                {helpText ? (
                  <Fragment>
                    {/* {description && !hasParentTable ? 
                              <p component="legend" className="control-label">
                                {finalText}
                              </p> :
                              ''
                            } */}
                    <InfoTooltip
                      toolTipText={helpText}
                      labelText={this.renderDatePicker()}
                      labelClassName="date-control-tooltip-label"
                      className="date-control-tooltip"
                    />
                  </Fragment>
                ) : (
                  this.renderDatePicker()
                )}
              </div>
            </div>
          }
        </div>
      </Fragment>
    );
  }
}
